export var NEW_COURSES_COUNT = 6;
export var NEW_COURSES_ORDER_BY_VALUE = 'nuevos';